import { render, staticRenderFns } from "./AChangeDialog.vue?vue&type=template&id=9910c860"
import script from "./AChangeDialog.vue?vue&type=script&lang=ts"
export * from "./AChangeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ABtn: require('/codebuild/output/src1267955449/src/app/components/atoms/Btn/ABtn.vue').default})
